import { render } from "./EOIWaitlistConfirmation.vue?vue&type=template&id=33bc4ab9&scoped=true&ts=true&lang=pug"
import script from "./EOIWaitlistConfirmation.vue?vue&type=script&lang=ts&setup=true"
export * from "./EOIWaitlistConfirmation.vue?vue&type=script&lang=ts&setup=true"

import "./EOIWaitlistConfirmation.vue?vue&type=style&index=0&id=33bc4ab9&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33bc4ab9"]])

export default __exports__